export const Tour_Variant_A: string = "tour-variant-a";
export const Tour_Variant_B: string = "tour-variant-b";
